import React, { useState } from "react";
import { useAuth } from "../../contexts/AuthContext";
import { useNavigate } from "react-router-dom";
import { getCurrentUser } from "../../services/moodle/userauth";
import { GoogleLoginButton } from "./GoogleLoginButton";
import { MicrosoftLoginButton } from "./MicrosoftLoginButton";

function LoginFormV2({
  handleSubmit,
  credentials,
  handleChange,
  loading,
  setShowForgotPassword,
}) {
  const { lang, dictionary, setUser } = useAuth();
  const navigate = useNavigate();
    const [googleLoading, setGoogleLoading] = useState(false);
    const [microsoftLoading, setMicrosoftLoading] = useState(false); // ✅ NUEVO
  const [error, setError] = useState(null);

  // ✅ Manejar login exitoso con Google
  const handleGoogleSuccess = async ({ key, username, token, userid }) => {
    try {
      setGoogleLoading(true);
      setError(null);

      console.log('🔵 Autenticando usuario:', { username, token });

      // Obtener datos completos del usuario
      const user = await getCurrentUser({ token, username });

      console.log('✅ Usuario obtenido:', user);

      // Guardar en localStorage
      localStorage.setItem('token', token);
      localStorage.setItem('username', username);
      localStorage.setItem('userid', userid);

      // Actualizar contexto de Auth
      setUser({ ...user, token });

      // Redirigir al listado de cursos
      navigate('/listcourses');
    } catch (error) {
      console.error('❌ Error al obtener usuario:', error);
      setError('Error al completar autenticación');
    } finally {
      setGoogleLoading(false);
    }
  };

  // ✅ Manejar errores de Google
  const handleGoogleError = (errorMessage) => {
    console.error('❌ Error Google:', errorMessage);
    setError(errorMessage);
  };

  /*   const handleLogin = () => {
    // --- Valores finales para tu configuración ---
    const serviceId =2;
    console.log(reactCallbackUrl)
    // ---------------------------------------------

    // Construye la URL que apunta a tu primer script PHP
    const initiationUrl = `${moodleDomain}/local/tipddy/services/iniciar_login_google.php?id=${serviceId}&wantsurl=${encodeURIComponent(encodeURIComponent(reactCallbackUrl))}`;

    // Redirige al usuario para iniciar el flujo
    window.location.href = initiationUrl;
  }; */

/*   const handleLoginGoogle = () => {
  const moodleDomain = "https://admin.aprendersteam.com";
  const reactCallbackUrl = `${window.location.origin}/callback`;
  
  // Solo pasas el wantsurl final (React), NO el callback de Moodle
  const url = `${moodleDomain}/local/tipddy/services/iniciar_login_google.php?` +
    new URLSearchParams({
      id: 1,
      wantsurl: reactCallbackUrl // ✅ Solo esto
    }).toString();

  console.log('🔵 Login URL:', url);
  console.log('🔵 Callback esperado:', reactCallbackUrl);
  
  window.location.href = url;
  }; */
  
    // ✅ NUEVO: Handler para Microsoft
  const handleMicrosoftSuccess = async ({ key, username, token, userid }) => {
    try {
      setMicrosoftLoading(true);
      setError(null);

      console.log('🔵 Autenticando usuario Microsoft:', { username, token });

      const user = await getCurrentUser({ token, username });

      console.log('✅ Usuario obtenido:', user);

      localStorage.setItem('token', token);
      localStorage.setItem('username', username);
      localStorage.setItem('userid', userid);

      setUser({ ...user, token });

      navigate('/listcourses');
    } catch (error) {
      console.error('❌ Error al obtener usuario:', error);
      setError('Error al completar autenticación con Microsoft');
    } finally {
      setMicrosoftLoading(false);
    }
  };
  // ✅ NUEVO: Handler de errores Microsoft
  const handleMicrosoftError = (errorMessage) => {
    console.error('❌ Error Microsoft:', errorMessage);
    setError(errorMessage);
  };
  return (
    <form
      onSubmit={handleSubmit}
      className="flex flex-col h-full justify-around"
    >
      {error && (
        <div
          role="alert"
          className="mb-4 text-[13px] text-red-600 bg-red-50 border border-red-200 rounded-lg px-4 py-2"
        >
          {error}
        </div>
      )}
      <div className="space-y-6">
        {/* Email Field */}
        <div>
          <label
            htmlFor="username"
            className="block text-base  tablet:text-2xl font-medium text-gray-700 mb-2"
          >
            {dictionary.Login.username}
          </label>
          <input
            type="text"
            id="username"
            name="username"
            value={credentials.username}
            onChange={handleChange}
            placeholder="Example@email.com"
            className="w-full text-base  tablet:text-2xl px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
            required
          />
        </div>

        {/* Password Field */}
        <div>
          <label
            htmlFor="password"
            className="block text-base  tablet:text-2xl  font-medium text-gray-700 mb-2"
          >
            {dictionary.Login.password}
          </label>
          <input
            type="password"
            id="password"
            name="password"
            value={credentials.password}
            onChange={handleChange}
            placeholder="At least 8 characters"
            className="w-full text-base  tablet:text-2xl  px-4 py-3 border border-gray-300 rounded-lg focus:ring-2 focus:ring-purple-500 focus:border-transparent outline-none transition-all"
            required
          />
        </div>

        {/* Forgot Password */}
        <div className="text-right !mt-2 !mb-2">
          <button
            type="button"
            onClick={() => setShowForgotPassword(true)}
            className="text-[13px] text-gray-600 hover:text-purple-600 transition-colors"
          >
            {dictionary.Login.recovery}
          </button>
        </div>
      </div>

      {/* Grupo Inferior: Botones */}
      <div className="space-y-4 mx-auto text-center w-full max-w-[400px]">
        {/* Sign In Button */}
        <button
          type="submit"
          disabled={loading}
          className="w-full max-w-[600px] bg-[#44BCF9]  hover:bg-[#41Bad8] text-[14px]  tablet:text-[18px] text-white font-semibold py-3 px-4 rounded-lg transition-colors disabled:opacity-50 disabled:cursor-not-allowed"
        >
          {loading ? "Iniciando sesión..." : dictionary.Login.send}
        </button>

        {/* Divider */}
        <div className="relative my-4 w-full max-w-[400px]">
          <div className="absolute inset-0 flex items-center">
            <div className="w-full border-t border-gray-300"></div>
          </div>
          <div className="relative flex justify-center text-md">
            <span className="px-2 bg-[#EDEDED] text-gray-500">
              {dictionary.Login.or}
            </span>
          </div>
        </div>

        {/* Google Sign In */}
        {/* ✅ NUEVO: Google Login con componente personalizado */}
        {/* <div className="flex justify-center"> */}
        <div className="flex w-[280px] justify-center **:font-poppins google-login-container">

          {googleLoading ? (
            <div className="w-full py-3 text-center text-gray-600">
              Autenticando con Google...
            </div>
          ) : (
            <GoogleLoginButton
            onSuccess={handleGoogleSuccess}
            onError={handleGoogleError}
            lang={lang}
            text={dictionary.Login.google}
            />
          )}
          </div>
          {/* ✅ NUEVO: Microsoft Sign In */}
        <div className="flex justify-center">
          {microsoftLoading ? (
            <div className="w-full py-3 text-center text-gray-600">
              Autenticando con Microsoft...
            </div>
          ) : (
            <MicrosoftLoginButton
              onSuccess={handleMicrosoftSuccess}
              onError={handleMicrosoftError}
              lang={lang}
              text={dictionary.Login.microsoft}
            />
          )}
        </div>
        
      </div>
    </form>
  );
}

export default LoginFormV2;
